module.exports = "<p>\n  callback works!\n</p>\n"